import {useEffect, useState} from "react";
import {BookablesService} from "@hps/hops-sdk-js";
import {Select} from "Components/Select";
import {useFetch} from "Hooks/useFetch";

/**
 * Bookable unit type picker
 *
 * @param {Object} props
 * @return {ReactNode}
 */
export const BookablesUnitTypePicker = props => {

	const [options, setOptions] = useState([]);

	const {data, loading, error} = useFetch({
		fn: () => BookablesService.getUnitTypes(),
		dep: []
	});

	useEffect(() => {
		const opts = [{
			label: "Select...",
			value: null
		}];

		for (const unit of (data || [])) {
			opts.push({
				label: unit.Name,
				value: unit
			});
		}

		setOptions(opts);
	}, [data]);

	return (
		<Select
			disabled={props.disabled}
			placeholder={props.placeholder}
			loading={loading}
			error={error}
			name={props.name}
			onChange={props.onChange}
			options={options}
			required={props.required}
			getOptionValue={o => o.value?.Id}
			value={props.value?.Id} />
	);

};
